const ENDPOINTS = {
    UPLOAD :'/file_management/upload',
    UPLOAD_LOGS : '/file_management/uploads'
  };
  
  export default ENDPOINTS;
  